export const TableHelpers = {
    data() {
      return {
        tableColumns: [
          {
            title: "Expediente",
            type: "custom-html",
            key: "record",
            modifier: (value, row) => {
              return `<a href="/accreditations/applications/${
                row.id
              }" target="_blank">${value || ""}</a>`;
            },
          },
          // {
          //   title: this.$t("Tipo Solicitud"),
          //   type: "custom-html",
          //   key: "accreditation_activity",
          //   modifier: (value) => {
          //     return value.application_name;
          //   },
          // },
          {
            title: this.$t("Tipo acreditación"),
            type: "custom-html",
            key: "accreditation_type",
            modifier: (value) => {
              return value.name;
            },
          },
          {
            title: "OEC",
            type: "custom-html",
            key: "organization",
            modifier: (value) => {
              return value.business_name;
            },
          },
          {
            title: "Fecha resolución",
            type: "text",
            key: "resolution_date",
          },
          // {
          //   title: "Días Disponibles",
          //   type: "custom-html",
          //   key: "accreditation_time",
          //   modifier: (value) => {
          //     let tmp;
          //     if (value) {
          //       if (value.remaining_days > 0) {
          //         tmp = `<span class="badge badge-sm badge-pill badge-success">${value.remaining_days}</span>`;
          //       } else {
          //         tmp =
          //           '<span class="badge badge-sm badge-pill badge-danger">Días Vencidos</span>';
          //       }
          //     }
          //     return tmp;
          //   },
          // },
        ],
        actionObj: {
          title: this.$t("action"),
          type: "action",
        },
      };
    },
  };
  